
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { GenderType, GenderPayloadType } from "@/common/types/gender";

export async function genderList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `gender/list${queryString}`
    );
}

export async function genderGet(
    gender_id: string
) {
    return await clientAxios.get(
        `gender/${gender_id}/show`
    );
}

export async function genderAdd(
    payload: GenderPayloadType
) {
    return await clientAxios.post(
        `gender/create`,
        payload
    );
}

export async function genderPatch(
    gender_id: string,
    payload: Partial<GenderType>
) {
    return await clientAxios.patch(
        `gender/${gender_id}/patch`,
        { payload }
    );
}

export async function genderDel(
    gender_id: string,
) {
    return await clientAxios.del(
        `gender/${gender_id}/delete`,
    );
}
